import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { map, switchMap } from 'rxjs/operators';
import {UserService} from "../../services/user.service";

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const userService = inject(UserService);
  const router = inject(Router);

  return auth.isAuthenticated$.pipe(
    switchMap(() => auth.user$),
    switchMap((user) => userService.getUserByEmail(user?.email as string)),
    map(user => {
      if (user.active && user.superAdmin) {
        return true;
      }
      return router.createUrlTree(['/access-denied']);
    })
  );
};
